<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="sunleon-container-parametre">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h5>Simulations enregistrées</h5>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Numéro de simulation"
                  [(ngModel)]="filterId"
                  (ngModelChange)="updateFilteredSummaries()"
                  (focus)="onInputFocus($event)"
                />
              </div>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nom du projet"
                  [(ngModel)]="filterNomProjet"
                  (ngModelChange)="updateFilteredSummaries()"
                  (focus)="onInputFocus($event)"
                />
              </div>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nom de l'utilisateur"
                  [(ngModel)]="filterNomUtilisateur"
                  (ngModelChange)="updateFilteredSummaries()"
                  (focus)="onInputFocus($event)"
                />
              </div>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Prénom de l'utilisateur"
                  [(ngModel)]="filterPrenomUtilisateur"
                  (ngModelChange)="updateFilteredSummaries()"
                  (focus)="onInputFocus($event)"
                />
              </div>
              <div class="mb-3">
                <input
                  type="date"
                  class="form-control"
                  placeholder="Date de création"
                  [(ngModel)]="filterDate"
                  (ngModelChange)="updateFilteredSummaries()"
                  (focus)="onInputFocus($event)"
                />
              </div>
              <ng-select
                class="mb-3"
                [items]="filteredSummaries"
                bindValue="id"
                bindLabel="nomProjet"
                [(ngModel)]="selectedId"
                placeholder="Rechercher ou sélectionner une simulation"
                [searchable]="false"
                [searchFn]="customSearchFn"
                [clearable]="true"
                [loading]="loading"
              >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.nomProjet }} ({{ item.id }}) - {{ item.prenomUtilisateur }} {{ item.nomUtilisateur }}
                </ng-template>
              </ng-select>
              <button
                class="btn btn-primary"
                (click)="applySimulation()"
                [disabled]="!selectedId"
              >
                Appliquer la simulation
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>